import React from 'react';
import { MdAddCircle, MdRemoveCircle } from 'react-icons/md';
import { TransparentButton, Icon } from "../..";
export var AddRemoveInputButton = function (_a) {
    var as = _a.as, onClick = _a.onClick, id = _a.id;
    return (React.createElement(TransparentButton, { id: id + "-" + as, type: "button", onClick: onClick, lss: { minHeight: '38px', px: 'xs' }, "aria-label": as + " option" },
        React.createElement(Icon, { as: as === 'add' ? MdAddCircle : MdRemoveCircle, size: 20, lss: {
                color: 'gray300',
                ':hover': { color: as === 'add' ? 'emerald500' : 'ruby500' },
                transition: 'fast'
            } })));
};
//# sourceMappingURL=AddRemoveInputButton.js.map